import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Tabs of the settings page
export type SettingSubPage = 'account' | 'billing';

interface SettingState {
  subPage: SettingSubPage;
}

const INITIAL_STATE: SettingState = {
  subPage: 'account',
};

const settingSlice = createSlice({
  name: 'settings',
  initialState: INITIAL_STATE,
  reducers: {
    changeSubPage: (state, action: PayloadAction<SettingSubPage>) => {
      state.subPage = action.payload;
    },

    logout: () => INITIAL_STATE,
  },
});

export const { changeSubPage } = settingSlice.actions;

export const settingReducer = settingSlice.reducer;
